import { Accessor, createContext, createEffect, createMemo, createSignal, JSX, JSXElement, Setter, Signal, ValidComponent } from "solid-js";
import { position, requireContext } from "common";

export class GroupDef {
    label: string;
    items: JSXElement[];

    constructor(label: string) {
        this.label = label;
        this.items = [];
    }
}

export class SelectContext<T extends string | any = string> {
    hasTrigger = false;
    open: Accessor<boolean>; setOpen: Setter<boolean>;
    value: Accessor<T>; setValue: Setter<T>;
    groups: Accessor<GroupDef[]>; setGroups: Setter<GroupDef[]>;
    trigger: Accessor<JSXElement | undefined>; setTrigger: Setter<JSXElement | undefined>;
    content: Accessor<ValidComponent>; setContent: Setter<ValidComponent>;
    placement: Accessor<position.Placement>; setPlacement: Setter<position.Placement>;
    defaultDisplayValue: Accessor<JSXElement>; setDefaultDisplayValue: Setter<JSXElement>;

    constructor(value: Signal<T>, open: Signal<boolean>) {
        [this.value, this.setValue] = value;
        [this.open, this.setOpen] = open;

        [this.placement, this.setPlacement] = createSignal<position.Placement>('bottom-start');

        [this.groups, this.setGroups] = createSignal<GroupDef[]>([]);
        [this.trigger, this.setTrigger] = createSignal<JSXElement>();
        [this.content, this.setContent] = createSignal<ValidComponent>('ul');
        [this.defaultDisplayValue, this.setDefaultDisplayValue] = createSignal(<>{this.value()}</>);
    }

    triggerEl?: HTMLElement;
    contentEl?: HTMLElement;
    bindTriggerEvents(el: HTMLElement) {
        el.addEventListener('mousedown', ev => ev.stopPropagation());
        el.addEventListener('click', () => {
            this.setOpen(!this.open());
            this.resetWatcher();
        })

        this.triggerEl = el;
        this.resetWatcher();
    }

    private cleanupWatcher: () => void = () => { }
    resetWatcher() {
        requestAnimationFrame(() => {
            this.cleanupWatcher()

            const trigger = this.triggerEl;
            const content = this.contentEl;
            if (trigger && content) {
                this.cleanupWatcher = position.observePosition(trigger, content, () => {
                    const { x, y } = position.computePosition(trigger, content, { placement: this.placement() })
                    content.style.left = `${x}px`;
                    content.style.top = `${y}px`;
                })
            }
        })
    }
}

const SelectContextJSX = createContext<SelectContext>();

export const SelectProvider = SelectContextJSX.Provider;

export function requireSelectContext<T extends string | any = string>() {
    return requireContext(SelectContextJSX) as unknown as SelectContext<T>
}